// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1RWb5","messages":"Chat_messages__23ZvA","dateDivider":"Chat_dateDivider__1Q5Oq"};